// Module-level store for the in-memory JWT access token.
//
// Extracted from AuthContext.js so that `_apiClient.js` (and the V2 services
// that depend on it) can read the token without going through AuthContext.js,
// which would create an import cycle that react-refresh trips on in dev mode
// (see AuthContextV2.js for the long version).

let _accessToken = null;
const _listeners = new Set();

export const getAccessToken = () => _accessToken;

export const setAccessToken = (token) => {
  _accessToken = token;
  _listeners.forEach((fn) => fn(token));
};

export const onAccessTokenChange = (fn) => {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
};
